import React, { useState, useMemo } from 'react';
import NavigationBar from '../navbar/NavigationBar';
import Footer from '../navbar/Footer';
import SideMenu from '../navbar/SideMenu';
import SideMenuBuhumuza from  '../navbar/SideMenuBujumbura'; 
import {
  Box,
  Typography,
  Container,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Grid,
  TextField,
  List, 
  ListItem, 
  ListItemText,
  CssBaseline,
  Drawer,
  InputAdornment,
  Button,
  useTheme,
  styled,
  useMediaQuery,
  Collapse,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Card,
  CardContent,
  Chip,
  LinearProgress,
  Stack
} from '@mui/material';

import {
  ExpandLess,
  Search,
  Menu as MenuIcon,
  ExpandMore,
  LocationOn,
  TrendingUp,
  TrendingDown,
  Group
} from '@mui/icons-material';


const drawerWidth = 240;
const rightDrawerWidth = 280; 
const primaryColor = '#E30613';
const secondaryColor = '#008D36';
const backgroundColor = '#f5f5f5';


const MainContainer = styled('div')({
  display: 'flex',
  backgroundColor: backgroundColor,
  minHeight: '100vh',
  flexDirection: 'column'
});

const MainContentWithDrawer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexGrow: 1,
  marginTop: '64px',
  overflow: 'hidden',
  [theme.breakpoints.down('sm')]: {
    marginTop: '56px'
  }
}));

const ContentWrapper = styled('main')(({ theme }) => ({
  flexGrow: 1,
  overflow: 'auto',
  padding: theme.spacing(2),
  backgroundColor: backgroundColor,
  height: 'calc(100vh - 64px)',
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(1),
    height: 'calc(100vh - 56px)'
  }
}));

const DrawerWrapper = styled('div')(({ theme }) => ({
  width: drawerWidth,
  flexShrink: 0,
  overflow: 'auto',
  height: 'calc(100vh - 64px)',
  borderRight: '1px solid rgba(0, 0, 0, 0.12)',
  backgroundColor: '#fff',
  [theme.breakpoints.down('md')]: {
    position: 'fixed',
    zIndex: 1300,
    transition: theme.transitions.create('transform', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    '&.drawerOpen': {
      transform: 'translateX(0)',
    },
    '&.drawerClose': {
      transform: 'translateX(-100%)',
    },
  }
}));

const RightDrawerWrapper = styled('div')(({ theme }) => ({
  width: rightDrawerWidth,
  flexShrink: 0,
  overflow: 'auto',
  height: 'calc(100vh - 64px)',
  borderLeft: '1px solid rgba(0, 0, 0, 0.12)',
  backgroundColor: '#fff',
  [theme.breakpoints.down('md')]: {
    position: 'fixed',
    right: 0,
    zIndex: 1300,
    transition: theme.transitions.create('transform', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    '&.drawerOpen': {
      transform: 'translateX(0)',
    },
    '&.drawerClose': {
      transform: 'translateX(100%)',
    },
  }
}));

const StyledTableHead = styled(TableHead)({
  backgroundColor: primaryColor,
  '& th': {
    color: 'white',
    fontWeight: 'bold'
  }
});

const ZoneRow = styled(TableRow)({
  backgroundColor: '#f8f8f8',
  fontWeight: 'bold',
  '&:hover': {
    backgroundColor: '#e8e8e8 !important'
  }
});

const isareData = {
  title: "RÉPARTITION DE LA POPULATION DE LA COMMUNE D'ISARE PAR ZONE ET COLLINE",
  province: {
    id: "1",
    name: "BUHUMUZA",
    commune: {
      id: "106",
      name: "ISARE",
      total: 149026,
      zones: [
        {
          id: "10601",
          name: "KIBUYE",
          total: 27369,
          collines: [
            { id: "10601101", name: "KIBUYE", population: 8516 },
            { id: "10601102", name: "SAGARA", population: 6960 },
            { id: "10601103", name: "NYARUKERE", population: 5347 },
            { id: "10601104", name: "RUSHA", population: 4304 },
            { id: "10601105", name: "BUYIMBA", population: 2242 }
          ]
        },
        {
          id: "10602",
          name: "KIRAMA",
          total: 18316,
          collines: [
            { id: "10602101", name: "KAVYA", population: 4834 },
            { id: "10602102", name: "GATEBE", population: 3789 },
            { id: "10602103", name: "RUBAYA", population: 2896 },
            { id: "10602104", name: "MUTURIRWA", population: 2952 },
            { id: "10602105", name: "RUTUNDA", population: 1952 },
            { id: "10602106", name: "GASENYI", population: 1893 }
          ]
        },
        {
          id: "10603",
          name: "MAGEYO",
          total: 29565,
          collines: [
            { id: "10603101", name: "KINAMA", population: 5015 },
            { id: "10603102", name: "MUHORORO", population: 5275 },
            { id: "10603103", name: "KARUGAMBA", population: 5257 },
            { id: "10603104", name: "MAGEYO", population: 4612 },
            { id: "10603105", name: "MUYABARA", population: 2691 },
            { id: "10603106", name: "BUHANDA", population: 3687 },
            { id: "10603107", name: "GITWE", population: 3028 }
          ]
        },
        {
          id: "10604",
          name: "MARTYAZO",
          total: 15805,
          collines: [
            { id: "10604101", name: "KANYINYA", population: 2937 },
            { id: "10604102", name: "BURENZA", population: 3412 },
            { id: "10604103", name: "KIGUNGA", population: 3551 },
            { id: "10604104", name: "KINYINYA", population: 2209 },
            { id: "10604105", name: "BUTEGA", population: 2345 },
            { id: "10604106", name: "MAGARURE", population: 1351 }
          ]
        },
        {
          id: "10605",
          name: "MUBIMBI",
          total: 17078,
          collines: [
            { id: "10605101", name: "MUBIMBI", population: 2863 },
            { id: "10605102", name: "KIZIBA", population: 3507 },
            { id: "10605103", name: "NYANKUBA", population: 3151 },
            { id: "10605104", name: "GISAGARA", population: 5621 },
            { id: "10605105", name: "MUZAZI", population: 1936 }
          ]
        },
        {
          id: "10606",
          name: "RUSHUBI",
          total: 27947,
          collines: [
            { id: "10606101", name: "RUSHUBI", population: 7987 },
            { id: "10606102", name: "RUTEGAMA", population: 6030 },
            { id: "10606103", name: "CARANKA", population: 4831 },
            { id: "10606104", name: "CIRISHA", population: 3028 },
            { id: "10606105", name: "BIBARE", population: 2615 },
            { id: "10606106", name: "NYARUMPONGO", population: 3456 }
          ]
        },
        {
          id: "10607",
          name: "RYARUSERA",
          total: 12946,
          collines: [
            { id: "10607101", name: "GISHUBI", population: 2777 },
            { id: "10607102", name: "ZINGA", population: 451 },
            { id: "10607103", name: "GAKENKE", population: 2803 },
            { id: "10607104", name: "MUGOMERE", population: 2034 },
            { id: "10607105", name: "KAYOYO", population: 1566 },
            { id: "10607106", name: "MUHWEZA", population: 1784 },
            { id: "10607107", name: "MWURA", population: 1531 }
          ]
        }
      ]
    }
  }
};

const PopulationDataPageBujumburaIsare = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [searchTerm, setSearchTerm] = useState('');
  const [mobileOpen, setMobileOpen] = useState(false);
  const [mobileRightOpen, setMobileRightOpen] = useState(false);
  const [expandedZones, setExpandedZones] = useState({});
  const [openKeyStats, setOpenKeyStats] = useState(true);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleRightDrawerToggle = () => {
    setMobileRightOpen(!mobileRightOpen);
  };

  const toggleZone = (zoneId) => {
    setExpandedZones(prev => ({
      ...prev,
      [zoneId]: !prev[zoneId]
    }));
  };

  const filterData = (data, searchTerm) => {
    if (!searchTerm) return data;
    
    const filteredZones = data.province.commune.zones.map(zone => {
      const filteredCollines = zone.collines.filter(colline =>
        colline.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        zone.name.toLowerCase().includes(searchTerm.toLowerCase())
      );
      
      return {
        ...zone,
        collines: filteredCollines,
        show: filteredCollines.length > 0 || 
              zone.name.toLowerCase().includes(searchTerm.toLowerCase())
      };
    }).filter(zone => zone.show || !searchTerm);
    
    return {
      ...data,
      province: {
        ...data.province,
        commune: {
          ...data.province.commune,
          zones: filteredZones
        }
      }
    };
  };

  const filteredData = filterData(isareData, searchTerm);

  const keyStats = useMemo(() => {
    const commune = isareData.province.commune;
    
    const mostPopulatedZone = commune.zones.reduce((max, zone) => 
      zone.total > max.total ? zone : max, commune.zones[0]);
    
    const leastPopulatedZone = commune.zones.reduce((min, zone) => 
      zone.total < min.total ? zone : min, commune.zones[0]);
    
    const mostPopulatedColline = commune.zones.flatMap(zone => zone.collines)
      .reduce((max, colline) => colline.population > max.population ? colline : max, commune.zones[0].collines[0]);
    
    const leastPopulatedColline = commune.zones.flatMap(zone => zone.collines)
      .reduce((min, colline) => colline.population < min.population ? colline : min, commune.zones[0].collines[0]);

    const zonePercentages = commune.zones.map(zone => ({
      ...zone,
      percentage: ((zone.total / commune.total) * 100).toFixed(1)
    }));
    
    return {
      totalPopulation: commune.total.toLocaleString(),
      totalZones: commune.zones.length,
      totalCollines: commune.zones.reduce((sum, zone) => sum + zone.collines.length, 0),
      mostPopulatedZone,
      leastPopulatedZone,
      mostPopulatedColline,
      leastPopulatedColline,
      zonePercentages,
      communeTotal: commune.total
    };
  }, []);

  return (
    <MainContainer>
      <CssBaseline />
      <NavigationBar />
      <MainContentWithDrawer>
        {!isMobile ? (
          <DrawerWrapper>
            <SideMenu /> 
          </DrawerWrapper>
        ) : (
          <Drawer
            variant="temporary"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            ModalProps={{
              keepMounted: true,
            }}
            sx={{
              '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
            }}
          >
            <SideMenu />
          </Drawer>
        )}

       
        <ContentWrapper>
          <Container maxWidth="lg">
            {isMobile && (
              <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                <Button 
                  variant="outlined" 
                  startIcon={<MenuIcon />} 
                  onClick={handleDrawerToggle}
                  sx={{ color: primaryColor, borderColor: primaryColor }}
                >
                  Menu
                </Button>
                <Button 
                  variant="outlined" 
                  endIcon={<MenuIcon />} 
                  onClick={handleRightDrawerToggle}
                  sx={{ color: secondaryColor, borderColor: secondaryColor }}
                >
                  Info ISARE
                </Button>
              </Box>
            )}
            
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Paper sx={{ p: { xs: 1, sm: 3 }, mb: 3, borderLeft: `4px solid ${primaryColor}` }}>
                  <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'space-between', alignItems: { xs: 'flex-start', sm: 'center' }, mb: 2 }}>
                    <Typography variant="body1" component="h2" fontWeight="bold" color="primary" sx={{ mb: { xs: 1, sm: 0 } }}>
                      {isareData.title}
                    </Typography>
                    <Chip 
                      icon={<Group />} 
                      label={`Commune d'ISARE`} 
                      color="primary" 
                      variant="outlined" 
                    />
                  </Box>
                  
                  <Grid container spacing={1} style={{ marginTop: '5px', marginBottom: '5px' }}>
                    <Grid item xs={12} sm={6} md={6}></Grid>
                    <Grid item xs={12} sm={6} md={6}>
                      <TextField
                        size="small"
                        placeholder="Rechercher zone/colline..."
                        variant="outlined"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <Search />
                            </InputAdornment>
                          ),
                        }}
                        sx={{ width: { xs: '100%', sm: '400px' } }}
                      />
                    </Grid>
                  </Grid>
                
                  <Accordion expanded={openKeyStats} onChange={() => setOpenKeyStats(!openKeyStats)} sx={{ mb: 3 }}>
                    <AccordionSummary expandIcon={<ExpandMore />}>
                      <Typography variant="subtitle1" fontWeight="bold">
                         Commune d'ISARE
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${primaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                                Population Totale
                              </Typography>
                              <Typography variant="h4" fontWeight="bold" color="primary">
                                {keyStats.totalPopulation}
                              </Typography>
                              <Typography variant="caption">
                                Habitants
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                        
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${secondaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                                Nombre de Zones
                              </Typography>
                              <Typography variant="h4" fontWeight="bold" color="secondary">
                                {keyStats.totalZones}
                              </Typography>
                              <Typography variant="caption">
                                Zones répertoriées
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                        
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${primaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                                Nombre de Collines
                              </Typography>
                              <Typography variant="h4" fontWeight="bold">
                                {keyStats.totalCollines}
                              </Typography>
                              <Typography variant="caption">
                                Collines répertoriées
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                        
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${secondaryColor}` }}>
                            <CardContent>
                              <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
                                <TrendingUp fontSize="small" color="success" />
                                <Typography variant="subtitle2" color="text.secondary">
                                  Zone la plus peuplée
                                </Typography>
                              </Stack>
                              <Typography variant="h6" fontWeight="bold">
                                {keyStats.mostPopulatedZone.name}
                              </Typography>
                              <Stack direction="row" spacing={1} alignItems="baseline">
                                <Typography variant="body1">
                                  {keyStats.mostPopulatedZone.total.toLocaleString()}
                                </Typography>
                                <Typography variant="caption" color="text.secondary">
                                  ({((keyStats.mostPopulatedZone.total / keyStats.communeTotal) * 100).toFixed(1)}%)
                                </Typography>
                              </Stack>
                            </CardContent>
                          </Card>
                        </Grid>
                        
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${primaryColor}` }}>
                            <CardContent>
                              <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
                                <TrendingDown fontSize="small" color="error" />
                                <Typography variant="subtitle2" color="text.secondary">
                                  Zone la moins peuplée
                                </Typography>
                              </Stack>
                              <Typography variant="h6" fontWeight="bold">
                                {keyStats.leastPopulatedZone.name}
                              </Typography>
                              <Stack direction="row" spacing={1} alignItems="baseline">
                                <Typography variant="body1">
                                  {keyStats.leastPopulatedZone.total.toLocaleString()}
                                </Typography>
                                <Typography variant="caption" color="text.secondary">
                                  ({((keyStats.leastPopulatedZone.total / keyStats.communeTotal) * 100).toFixed(1)}%)
                                </Typography>
                              </Stack>
                            </CardContent>
                          </Card>
                        </Grid>

                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${secondaryColor}` }}>
                            <CardContent>
                              <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
                                <TrendingUp fontSize="small" color="success" />
                                <Typography variant="subtitle2" color="text.secondary">
                                  Colline la plus peuplée
                                </Typography>
                              </Stack>
                              <Typography variant="h6" fontWeight="bold">
                                {keyStats.mostPopulatedColline.name}
                              </Typography>
                              <Typography variant="body1">
                                {keyStats.mostPopulatedColline.population.toLocaleString()}
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>

                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${primaryColor}` }}>
                            <CardContent>
                              <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
                                <TrendingDown fontSize="small" color="error" />
                                <Typography variant="subtitle2" color="text.secondary">
                                  Colline la moins peuplée
                                </Typography>
                              </Stack>
                              <Typography variant="h6" fontWeight="bold">
                                {keyStats.leastPopulatedColline.name}
                              </Typography>
                              <Typography variant="body1">
                                {keyStats.leastPopulatedColline.population.toLocaleString()}
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                      </Grid>

                     
                      <Box sx={{ mt: 3 }}>
                        <Typography variant="subtitle1" gutterBottom fontWeight="bold">
                          Répartition de la population par zone
                        </Typography>
                        {keyStats.zonePercentages.map((zone) => (
                          <Box key={zone.id} sx={{ mb: 2 }}>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                              <Typography variant="body2">
                                {zone.name}
                              </Typography>
                              <Typography variant="body2" fontWeight="bold">
                                {zone.percentage}% ({zone.total.toLocaleString()})
                              </Typography>
                            </Box>
                            <LinearProgress 
                              variant="determinate" 
                              value={zone.percentage} 
                              sx={{ 
                                height: 8, 
                                borderRadius: 4,
                                backgroundColor: '#e0e0e0',
                                '& .MuiLinearProgress-bar': {
                                  backgroundColor: zone.id === keyStats.mostPopulatedZone.id ? primaryColor : 
                                                zone.id === keyStats.leastPopulatedZone.id ? secondaryColor : '#888',
                                }
                              }} 
                            />
                          </Box>
                        ))}
                      </Box>
                    </AccordionDetails>
                  </Accordion>
                  
                  <TableContainer component={Paper} sx={{ mb: 2, overflowX: 'auto' }}>
                    <Table size="small" aria-label="Tableau des données démographiques">
                      <StyledTableHead>
                        <TableRow>
                          <TableCell>Zone/Colline</TableCell>
                          <TableCell align="right">Population</TableCell>
                        </TableRow>
                      </StyledTableHead>
                      <TableBody>
                        {filteredData.province.commune.zones.map((zone) => (
                          <React.Fragment key={zone.id}>
                            <ZoneRow 
                              hover 
                              onClick={() => toggleZone(zone.id)}
                              sx={{ cursor: 'pointer' }}
                            >
                              <TableCell component="th" scope="row" colSpan={2}>
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                  {expandedZones[zone.id] ? <ExpandLess /> : <ExpandMore />}
                                  <LocationOn sx={{ mr: 1, color: primaryColor }} />
                                  {zone.name}
                                </Box>
                              </TableCell>
                            </ZoneRow>
                            
                            <TableRow>
                              <TableCell style={{ padding: 0 }} colSpan={2}>
                                <Collapse in={expandedZones[zone.id] || !!searchTerm} timeout="auto" unmountOnExit>
                                  <Table size="small" sx={{ backgroundColor: '#fafafa' }}>
                                    <TableBody>
                                      {zone.collines.map((colline) => (
                                        <TableRow key={colline.id} hover>
                                          <TableCell sx={{ pl: 4 }}>{colline.name}</TableCell>
                                          <TableCell align="right">{colline.population.toLocaleString()}</TableCell>
                                        </TableRow>
                                      ))}
                                      <TableRow>
                                        <TableCell sx={{ pl: 4, fontWeight: 'bold' }}>Total {zone.name}</TableCell>
                                        <TableCell align="right" sx={{ fontWeight: 'bold' }}>{zone.total.toLocaleString()}</TableCell>
                                      </TableRow>
                                    </TableBody>
                                  </Table>
                                </Collapse>
                              </TableCell>
                            </TableRow>
                          </React.Fragment>
                        ))}
                        <TableRow sx={{ backgroundColor: '#e0e0e0', fontWeight: 'bold' }}>
                          <TableCell>TOTAL COMMUNE D'ISARE</TableCell>
                          <TableCell align="right">{isareData.province.commune.total.toLocaleString()}</TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>

                </Paper>
                
               
                <Accordion sx={{ mb: 2 }}>
                  <AccordionSummary expandIcon={<ExpandMore />}>
                    <Typography variant="subtitle2" color="primary">
                      Structure administrative - Commune d'ISARE
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography variant="body2" paragraph>
                      La commune d'ISARE est divisée en {keyStats.totalZones} zones administratives:
                    </Typography>
                    <List dense sx={{ py: 0 }}>
                      {keyStats.zonePercentages.map((zone, index) => (
                        <ListItem key={zone.id}>
                          <ListItemText 
                            primary={`${index + 1}. ${zone.name}`} 
                            secondary={`Population: ${zone.total.toLocaleString()} habitants (${zone.percentage}%) - ${zone.collines.length} collines`} 
                          />
                        </ListItem>
                      ))}
                    </List>
                  </AccordionDetails>
                </Accordion>
                
              
                <Paper sx={{ p: 2, backgroundColor: '#f0f0f0', borderLeft: `4px solid ${secondaryColor}` }}>
                  <Typography variant="subtitle2" gutterBottom color="primary">
                    Notes méthodologiques
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Les données présentées sont issues du Recensement Général de la Population. 
                    Les chiffres incluent uniquement la population des ménages ordinaires.
                    Les pourcentages sont calculés par rapport à la population totale de la commune d'ISARE ({keyStats.totalPopulation} habitants).
                  </Typography>
                </Paper>
              </Grid>
            </Grid>
          </Container>
        </ContentWrapper>

        
        {!isMobile ? (
          <RightDrawerWrapper>
            <SideMenuBuhumuza />
          </RightDrawerWrapper>
        ) : (
          <Drawer
            variant="temporary"
            anchor="right"
            open={mobileRightOpen}
            onClose={handleRightDrawerToggle}
            ModalProps={{
              keepMounted: true,
            }}
            sx={{
              '& .MuiDrawer-paper': { boxSizing: 'border-box', width: rightDrawerWidth },
            }}
          >
            <SideMenuBuhumuza /> 
          </Drawer>
        )}
      </MainContentWithDrawer>
      <Footer />
    </MainContainer>
  );
};

export default PopulationDataPageBujumburaIsare;